import { useTheme } from '../contexts/ThemeContext';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = ({ size = 'default' }) => {
  const { isDark, toggleTheme } = useTheme();
  
  const sizeClasses = {
    small: 'w-12 h-6',
    default: 'w-14 h-7',
    large: 'w-16 h-8',
  };
  
  const iconSizes = {
    small: 12,
    default: 14,
    large: 16,
  };

  return (
    <button
      onClick={toggleTheme}
      data-testid="theme-toggle"
      className={`
        relative ${sizeClasses[size]} rounded-full p-1
        transition-all duration-300 ease-in-out
        ${isDark 
          ? 'bg-[#1e3a5f] shadow-[0_0_15px_rgba(0,212,255,0.2)]' 
          : 'bg-[#c7d9ed] shadow-[0_2px_8px_rgba(0,0,0,0.1)]'
        }
      `}
      aria-label={isDark ? 'Activer le mode clair' : 'Activer le mode sombre'}
    >
      {/* Track glow effect */}
      <div 
        className={`
          absolute inset-0 rounded-full transition-opacity duration-300
          ${isDark ? 'opacity-100' : 'opacity-0'}
        `}
        style={{
          background: 'linear-gradient(90deg, rgba(0,212,255,0.1) 0%, rgba(200,230,0,0.1) 100%)',
        }}
      />
      
      {/* Sliding circle */}
      <div
        className={`
          relative h-full aspect-square rounded-full
          flex items-center justify-center
          transform transition-all duration-300 ease-out
          ${isDark 
            ? 'translate-x-0 bg-[#0d1829] shadow-[0_0_10px_rgba(0,212,255,0.5)]' 
            : 'translate-x-full bg-white shadow-[0_2px_4px_rgba(0,0,0,0.15)]'
          }
        `}
        style={{
          transform: isDark ? 'translateX(0)' : `translateX(calc(100% + 0.25rem))`,
        }}
      >
        {isDark ? (
          <Moon 
            size={iconSizes[size]} 
            className="theme-accent transition-transform duration-300"
          />
        ) : (
          <Sun 
            size={iconSizes[size]} 
            className="text-[#f59e0b] transition-transform duration-300"
          />
        )}
      </div>
      
      {/* Background icons */}
      <div className="absolute inset-0 flex items-center justify-between px-1.5 pointer-events-none">
        <Sun 
          size={iconSizes[size] - 2} 
          className={`transition-opacity duration-300 ${isDark ? 'opacity-30 text-zinc-500' : 'opacity-0'}`}
        />
        <Moon 
          size={iconSizes[size] - 2} 
          className={`transition-opacity duration-300 ${isDark ? 'opacity-0' : 'opacity-30 text-zinc-400'}`}
        />
      </div>
    </button>
  );
};

export default ThemeToggle;
